module.exports = __webpack_public_path__ + "static/media/setting-gray.1eb24872.svg";